import { Camera, ImageIcon, Share2, Star } from "lucide-react"

export function LandingPage() {
  const botUsername = (import.meta.env.VITE_TELEGRAM_BOT_USERNAME ?? "").replace("@", "")
  const appLink = `https://t.me/${botUsername}/app`

  return (
    <div className="min-h-screen bg-tg-bg flex flex-col items-center justify-center px-6 py-12 text-center">
      {/* Branding */}
      <div
        className="w-16 h-16 rounded-2xl flex items-center justify-center mb-5"
        style={{
          background:
            "linear-gradient(135deg, var(--gallery-accent), color-mix(in srgb, var(--gallery-accent) 80%, #6366f1))",
        }}
      >
        <Camera className="w-8 h-8 text-white" />
      </div>
      <h1 className="text-2xl font-bold text-tg-text tracking-tight">tg-gallery</h1>
      <p className="text-tg-hint text-base mt-1.5">Photo galleries for Telegram</p>

      {/* Features */}
      <div className="mt-10 space-y-4 max-w-xs w-full text-left">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-lg bg-tg-secondary flex items-center justify-center shrink-0 mt-0.5">
            <ImageIcon className="w-[18px] h-[18px] text-tg-accent" />
          </div>
          <div>
            <p className="text-sm font-medium text-tg-text">Create galleries</p>
            <p className="text-xs text-tg-hint mt-0.5">
              Send photos to the bot and organize them into beautiful galleries
            </p>
          </div>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-lg bg-tg-secondary flex items-center justify-center shrink-0 mt-0.5">
            <Share2 className="w-[18px] h-[18px] text-tg-accent" />
          </div>
          <div>
            <p className="text-sm font-medium text-tg-text">Share with friends</p>
            <p className="text-xs text-tg-hint mt-0.5">
              Share gallery links in chats, groups, and channels
            </p>
          </div>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-lg bg-tg-secondary flex items-center justify-center shrink-0 mt-0.5">
            <Star className="w-[18px] h-[18px] text-tg-accent" />
          </div>
          <div>
            <p className="text-sm font-medium text-tg-text">Monetize with Stars</p>
            <p className="text-xs text-tg-hint mt-0.5">
              Set a price in Telegram Stars to unlock premium galleries
            </p>
          </div>
        </div>
      </div>

      {/* CTA */}
      <a
        href={appLink}
        className="mt-10 inline-flex items-center gap-2 bg-tg-button text-tg-button-text px-8 py-3.5 rounded-xl font-semibold text-base btn-press"
      >
        Open in Telegram
      </a>

      <p className="text-tg-hint text-xs mt-4">
        Works inside the{" "}
        <a href="https://telegram.org" className="underline">
          Telegram
        </a>{" "}
        app
      </p>
    </div>
  )
}
